"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._CardModal = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _CardModalModule = _interopRequireDefault(require("../../styles/components/CardModal.module.css"));
var _ImagesTab2 = _interopRequireDefault(require("../TabsContent/_ImagesTab"));
var _DetailsTab2 = _interopRequireDefault(require("../TabsContent/_DetailsTab"));
var _ChartsTab2 = _interopRequireDefault(require("../TabsContent/_ChartsTab"));
var _constants = require("../../utils/constants");
var _hooks = require("../../hooks");
const _excluded = ["open", "handleOpenModal", "componentId"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const EmptyTab = props => {
  const {
    text = ''
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", null, text);
};
const getTabContentByKey = key => {
  switch (key) {
    case 'images':
      return _ImagesTab2.default;
    case 'details':
      return _DetailsTab2.default;
    case 'charts':
      return _ChartsTab2.default;
    default:
      return EmptyTab;
  }
};
const ModalContent = props => {
  const {
    componentId = null,
    handleOpenModal
  } = props;
  const component = (0, _hooks.useGetComponentById)({
    id: componentId
  });
  const {
    type = '',
    devicesId = []
  } = component;
  const [activeTab, setActiveTab] = (0, _react.useState)(0);
  const unFilteredTabs = _constants.configTabs[type] || {};
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.selectActiveTranslationsInterfaceUILocalizations);
  const tabs = Object.keys(unFilteredTabs).reduce((acc, tab) => {
    var _unFilteredTabs$tab, _unFilteredTabs$tab2;
    return tab === 'charts' && devicesId.length === 0 ? acc : _objectSpread(_objectSpread({}, acc), {}, {
      [tab]: _objectSpread(_objectSpread({}, unFilteredTabs[tab]), {}, {
        name: tI[(_unFilteredTabs$tab = unFilteredTabs[tab]) === null || _unFilteredTabs$tab === void 0 ? void 0 : _unFilteredTabs$tab.tNameKey] || ((_unFilteredTabs$tab2 = unFilteredTabs[tab]) === null || _unFilteredTabs$tab2 === void 0 ? void 0 : _unFilteredTabs$tab2.name)
      })
    });
  }, {}) || {};
  return (0, _react.useMemo)(() => {
    var _Object$values, _Object$values2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      className: "bg-color-main-color-form-bg mb-40 p-3"
    }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Tabs, {
      value: activeTab,
      onChange: (e, newValue) => setActiveTab(newValue),
      variant: "scrollable",
      scrollButtons: "auto",
      "aria-label": "example"
    }, (_Object$values = Object.values(tabs)) === null || _Object$values === void 0 ? void 0 : _Object$values.map((tab, index) => /*#__PURE__*/_react.default.createElement(_paulCorePackage.Tab, {
      label: (tab === null || tab === void 0 ? void 0 : tab.name) || '-',
      index: index,
      key: tab.id,
      disabled: tab.disabled
    })))), (_Object$values2 = Object.values(tabs)) === null || _Object$values2 === void 0 ? void 0 : _Object$values2.map((tab, index) => {
      const TabComponent = getTabContentByKey(tab.id);
      return /*#__PURE__*/_react.default.createElement(_paulCorePackage.TabPanel, {
        active: activeTab,
        value: index,
        key: tab.id
      }, /*#__PURE__*/_react.default.createElement(TabComponent, {
        text: "Content ".concat(tab.id),
        componentId: componentId,
        openFullSize: handleOpenModal,
        devicesId: devicesId,
        type: type
      }));
    }));
  }, [type, componentId, activeTab, devicesId, type]);
};
const _CardModal = props => {
  const {
      open = false,
      handleOpenModal,
      componentId = null
    } = props,
    p = _objectWithoutProperties(props, _excluded);
  const component = (0, _hooks.useGetComponentById)({
    id: componentId
  });
  const componentName = (0, _hooks.useGetComponentName)(component);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_paulCorePackage.Modal, {
    boxId: "details_card_modal",
    onClose: () => handleOpenModal(false),
    open: open,
    classNameHeader: "color-main-color-primary fw-bold",
    header: componentName,
    componentHeader: "p",
    hasCancelButton: true,
    classNameBox: _CardModalModule.default.card_modal_box
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(ModalContent, _extends({
    componentId: componentId,
    handleOpenModal: handleOpenModal
  }, p)))), [componentId, componentName, open]);
};
exports._CardModal = _CardModal;